<template>
  <svg
    class="instruction-icon"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 26"
    fill="none"
  >
    <path d="M7 0.500122H11V2.50012H7V0.500122Z" fill="#5898DB" />
    <path d="M7 23.5001H11V25.5001H7V23.5001Z" fill="#5898DB" />
    <path d="M14 0.500122H18V2.50012H14V0.500122Z" fill="#5898DB" />
    <path d="M14 23.5001H18V25.5001H14V23.5001Z" fill="#5898DB" />
    <path d="M21 0.500122H25V2.50012H21V0.500122Z" fill="#5898DB" />
    <path d="M30 7.50012H32V11.5001H30V7.50012Z" fill="#5898DB" />
    <path d="M0 14.5001H2V18.5001H0V14.5001Z" fill="#5898DB" />
    <path d="M0 7.50012H2V11.5001H0V7.50012Z" fill="#5898DB" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.7073 12.2072C19.0977 11.8168 19.731 11.8168 20.1213 12.2072L30 22.0859V18.5002C30 17.9479 30.4478 17.5002 31 17.5002C31.5522 17.5002 32 17.9479 32 18.5002V24.5002C32 25.0524 31.5522 25.5002 31 25.5002H25C24.4478 25.5002 24 25.0524 24 24.5002C24 23.9479 24.4478 23.5002 25 23.5002H28.5859L18.7073 13.6215C18.3167 13.2309 18.3167 12.5978 18.7073 12.2072Z"
      fill="#5898DB"
    />
    <path
      d="M2 0.500122H4V2.50012H2V4.50012H0V2.50012C0 1.39555 0.895431 0.500122 2 0.500122Z"
      fill="#5898DB"
    />
    <path
      d="M32 2.49988V4.49988H30V2.49988H28V0.499878L30 0.499878C31.1046 0.499878 32 1.39531 32 2.49988Z"
      fill="#5898DB"
    />
    <path
      d="M0 23.5001L0 21.5001H2L2 23.5001H4V25.5001H2C0.895431 25.5001 0 24.6047 0 23.5001Z"
      fill="#5898DB"
    />
  </svg>
</template>

<script>
export default {
  name: "InstructionIcon",
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 26,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.instruction-icon {
  path {
    fill: $aisea-blue;
  }
}
</style>
